import { render, staticRenderFns } from "./chooseCourse.vue?vue&type=template&id=7d1ea52e&"
import script from "./chooseCourse.vue?vue&type=script&lang=js&"
export * from "./chooseCourse.vue?vue&type=script&lang=js&"
import style0 from "./chooseCourse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports